export const catFilterCategories = [
  { key: 'brand', label: 'Brand' },
  { key: 'category', label: 'Category' },
  { key: 'age', label: 'Life Stage' },
  { key: 'breed', label: 'Breed' },
  { key: 'needs', label: 'Care/Health needs' },
  { key: 'sterilised', label: 'Sterilised' },
  { key: 'productSize', label: 'Product Size' },
]

export default catFilterCategories
